import React from 'react'
import { Tooltip } from '@instructure/ui-tooltip'
import { Pagination } from '@instructure/ui-pagination'
import { useDispatch, useSelector } from 'react-redux'
import { getCourseUsers } from '../../actions/courses.js'


const PaginationButton = ({ link, renderIcon, helperText }) => {
  const dispatch = useDispatch()
  const courseId = useSelector(state => state.canvas.canvasCourse?.courseId)
  const token = useSelector(state => state.userAccess.jwtToken)
  const current = useSelector(state => state.courses.users?.result?.links?.current)
  const isDisabled = !link?.url || current?.page === link?.page

  const onClick = () => {
    dispatch(getCourseUsers(courseId, token, link.url))
  }

  return (
    <Tooltip renderTip={helperText} on={['hover', 'focus']} placement="bottom">
      <span tabIndex={isDisabled ? 0 : null}>
        <Pagination.Page disabled={isDisabled} onClick={onClick} aria-label={helperText}>
          {renderIcon}
        </Pagination.Page>
      </span>
    </Tooltip>
  )
}

export default PaginationButton